import React, {useRef, useState, useEffect} from 'react';
import styled from 'styled-components';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import {Toast, toast} from '../noti/Toast'

// import {useLocation} from 'react-router-dom';

const ButtonBlock = styled.div`
//--social-bar-width: 300px;
//--btn-size: 28px;
//--bg-color: #ececec;
position:absolute;
width: ${props=>props.btnSize};
height: ${props=>props.btnSize};

.offscreen {    
    position: absolute;
    left: -999em;
}

.btn-container {
  position:absolute;
  width: ${props=>props.barWidth};
  right: 0; 
  .share-button {
  display: block;
  position: relative;
  border-radius: calc(${props=>props.btnSize}/2);
  height: ${props=>props.btnSize}; 
 
  &:hover {
    cursor: pointer;
    
    //.share-button-primary {
    //  box-shadow: 1px 0 0 0 rgba(0, 0, 0, .1);
    //}
    
    //.share-button-secondary-content {
    //  transform: translate3d(0, 0, 0);
    //}
  }
}
}  

.share-button-primary {
  position: absolute;
  top:0;
  right:0;
  background: ${props=>props.bgColor};
  width: ${props=>props.btnSize};
  height: ${props=>props.btnSize};
  border-radius: 50%;
  //left: 0;
  //top: 50%;
  //margin-top: -(${props=>props.btnSize} /  2); 
}

.share-button-icon {
  display: block;
  //color: #242424;
  position: absolute;
  width: ${props=>props.btnSize};
  line-height: ${props=>props.btnSize};
  //font-size: 16px;
  margin-top: 1px;
}

.share-button-secondary {
  overflow: hidden;
  //margin-left: calc(${props=>props.btnSize} / 2);
  //margin-left: 20px;
  height: ${props=>props.btnSize};
  //border-radius: calc(${props=>props.btnSize}/2);
  margin-right: calc(${props=>props.btnSize}/2);
  
}

.share-button-secondary-content{
  //width:${props=>props.btnSize};
  //visibility: hidden;
  //opacity:0;
  transform: translate3d(100%, 0, 0);
  //transition: transform .3s ease;
  transition: transform .3s ease;
  background: ${props=>props.bgColor};
  display: flex;
  //justify-content: space-around;
  height: ${props=>props.btnSize};
  //text-align: left;
  //padding-left: calc(${props=>props.btnSize} * .8);
  //padding-right: 28px;
  //padding-right: ${props=>props.btnSize};
  line-height: ${props=>props.btnSize};
  //color: #242424;
  //border-radius: calc(${props=>props.btnSize}/2);
  border-bottom-left-radius: calc(${props=>props.btnSize}/2);
  border-top-left-radius: calc(${props=>props.btnSize}/2);
  
  padding: 0 calc(${props=>props.btnSize}/2) 0  10px;
  &.active{    
    //width:100%;    
    font-family: sans-serif;
    font-size: .75em;
    //background: ${props=>props.bgColor};
    //display: flex;
    justify-content: space-around;
    //height: ${props=>props.btnSize};
    ////text-align: left;
    //padding-left: (${props=>props.btnSize} * .8);
    //padding-right: 28px;
    //line-height: ${props=>props.btnSize};
    ////color: #242424;
    //border-radius: calc(${props=>props.btnSize}/2);
     transform: translate3d(0, 0, 0);
     //border-radius: calc(${props=>props.btnSize}/2);
    

    img {width:${props=>props.btnSize};
    }  
  }
}
`;


const SocialShareBtn = (props) => {
    const kakaoId = "kakao-btn";
    const kakaoStoryId = "kakao-story-btn";
    const socialBtns = useRef(null);
    const linkToCopy = useRef(null);
    const [btnActive,setBtnActive] = useState(false);

    // useEffect(()=>{
    //
    //   if (!document.getElementById('KakaoJSSDK')) {
    //     const scriptKakaoJS = document.createElement('script');
    //     scriptKakaoJS.id = 'KakaoJSSDK';
    //     scriptKakaoJS.src = '//developers.kakao.com/sdk/js/kakao.min.js';
    //     document.body.appendChild(scriptKakaoJS);
    //   }
    //
    //
    //   (function checkKakao() {
    //     if (typeof window.Kakao === 'undefined') {
    //       setTimeout(checkKakao, 500);
    //     } else {
    //       window.Kakao.cleanup();
    //       console.log('INIT!!!!')
    //       window.Kakao.init(process.env.REACT_APP_KAKAO_JS);
    //     }
    //   })();
    // });
    const shareUrl = (target, props)=>{
        const targets = {d:{
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(props.url)}`,
                // kakaotalk:``,
                kakaostory:`https://story.kakao.com/share?url=${encodeURIComponent(props.url)}`,
                naverblog:`http://share.naver.com/web/shareView.nhn?url=${encodeURIComponent(props.url)}&title=${encodeURIComponent(props.pageTitle)}`,
                naverband:`https://band.us/plugin/share?body=${encodeURIComponent(props.pageTitle + `(${props.url})`)}&route=${props.url}`,
        }};

        if(target==='kakaotalk'){

          window.Kakao.Link.sendDefault({
            // container: '#${kakaoId}',
            objectType: 'feed',
            content: {
              title: props.pageTitle,
              imageUrl: props.image,
              link: {
                mobileWebUrl: props.url,
                webUrl: props.url
              }
            }
          });

        }
        else window.open(targets.d[target], "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=386")

    }

    const copyToClipBoard = () => {
      linkToCopy.current.select();
      document.execCommand('copy')
      // toast.success('링크를 복사했어요!', {
      //   position: "bottom-center",
      //   autoClose: 1000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // })
      toast('SUCCESS', '링크를 복사했어요!', false)

    }
    const showBtns = ()=>{
        btnActive?socialBtns.current.classList.remove('active'):socialBtns.current.classList.add('active');
        setBtnActive(!btnActive);
    }

    return (
        <ButtonBlock {...props}>
            <div className="btn-container">
                <div className="share-button">
                    <div className="share-button-secondary">
                        <div ref={socialBtns} className="share-button-secondary-content">
                            {/*<img title="페이스북 공유" alt="페이스북 공유" src="/assets/images/icon/facebook-ic.png" onClick={()=>shareUrl('facebook',props)}/>*/}
                            <img id={kakaoId} title="카카오톡에 공유" alt="카카오톡에 공유" src="/assets/images/icon/kakaoTalk-ic.png" onClick={()=>shareUrl('kakaotalk',props)}/>
                            <img id={kakaoStoryId} title="카카오스토리에 공유" alt="카카오스토리에 공유" src="/assets/images/icon/kakaoStory-ic.png" onClick={()=>shareUrl('kakaostory',props)}/>
                            <img title="네이버블로그에 공유" alt="네이버블로그에 공유" src="/assets/images/icon/blog-ic.png" onClick={()=>shareUrl('naverblog',props)}/>
                            <img title="네이버밴드에 공유" alt="네이버밴드에 공유" src="/assets/images/icon/band-ic.png" onClick={()=>shareUrl('naverband',props)}/>
                            <img title="링크 복사" alt="링크 복사" src="/assets/images/icon/link-ic.png" onClick={copyToClipBoard} />
                            <input ref={linkToCopy} className="offscreen" aria-hidden={true} readOnly value={props.url}/>
                        </div>
                    </div>
                    <div className="share-button-primary" title={btnActive?'닫기':'공유하기'} onClick={()=>showBtns()}>
                        {btnActive?<img className="share-button-icon" alt="닫기" src="/assets/images/icon/shareClose-ic.png" />:<img className="share-button-icon" alt="공유하기" src="/assets/images/icon/share-ic.png" />}
                    </div>
                </div>
            </div>
          <Toast/>
        </ButtonBlock>
    );
};

export default SocialShareBtn;
